import React, { useMemo } from "react";

import mapThemaToBisac from "astrid-helpers/src/themaToBisac/themaToBisac";

import Select from "../../../ui/components/Select/Select";

import Form from "../../../forms/components/Form/Form";

import useArticleBisacOptions from "../../hooks/useArticleBisacOptions";

export default function ArticleMetaDataBisacSelect({ name }) {
	const { watch } = Form.useFormContext();

	const themaCodes = watch("themaCodes");

	const suggestions = useMemo(() => {
		const { matches } = mapThemaToBisac(themaCodes);

		return matches.map(({ bisac }) => bisac);
	}, [themaCodes]);

	const options = useArticleBisacOptions({ suggestions });

	return (
		<Form.Field name={name}>
			<Select search multiple options={options} renderLabel={({ value }) => value} />
		</Form.Field>
	);
}
